import { h } from 'preact';
import { CacheProvider as EmotionCacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
const emotionCache = createCache({
    key: 'ss',
    prepend: true,
});
export const CacheProvider = (props) => {
    return h(EmotionCacheProvider, { value: props.cache || emotionCache }, props.children);
};
